<template>
    <i :class="getIconClassMap" :aria-hidden="ariaHidden" />
</template>

<script>
import "./icons.scss";

export default {
    name: "BodyStyleIcon",
    props: {
        bodyStyle: {
            type: String,
            required: true,
        },
        selected: {
            type: Boolean,
            required: false,
            default: false,
        },
        // added for ADA compliance - AC-19 -
        ariaHidden: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        getIconClassMap() {
            let cssClassMap = {};

            if (this.selected) {
                cssClassMap = `icon-${this.bodyStyle} selected`;
            } else {
                cssClassMap = `icon-${this.bodyStyle}-outline`;
            }

            return cssClassMap;
        },
    },
};
</script>
